import React__default from 'react';

function guardAstNode(node) {
  return node.type === "element" || node.type === "text";
}
function cloneElement(element, includeChildren = false) {
  return {
    ...element,
    properties: {
      ...element.properties
    },
    children: includeChildren ? [
      ...element.children
    ] : []
  };
}
function findOrCreateElement(current, parent) {
  const existing = current.children[current.children.length - 1];
  if (existing?.type === "element" && existing.tagName === parent.tagName && JSON.stringify(existing.properties) === JSON.stringify(parent.properties)) {
    return existing;
  }
  const newElement = cloneElement(parent);
  current.children.push(newElement);
  return newElement;
}
function splitAstByNewlines(root) {
  const lines = [];
  let currentLine = {
    type: "root",
    children: []
  };
  function addTextToLine(text, parentElements) {
    let current = currentLine;
    parentElements.forEach((parent) => {
      const element = findOrCreateElement(current, parent);
      current = element;
    });
    current.children.push({
      type: "text",
      value: text
    });
  }
  function finalizeLine() {
    lines.push(currentLine);
    currentLine = {
      type: "root",
      children: []
    };
  }
  function handleTextNode(node, parentElements) {
    const parts = node.value.split("\n");
    parts.forEach((part, index) => {
      if (index > 0) {
        finalizeLine();
      }
      if (part.length > 0) {
        addTextToLine(part, parentElements);
      }
    });
  }
  function processNode(node, parentElements = []) {
    if (node.type === "text") {
      handleTextNode(node, parentElements);
    } else if (node.type === "element") {
      const updatedParents = [
        ...parentElements,
        node
      ];
      node.children.forEach((child) => processNode(child, updatedParents));
    }
  }
  root.children.forEach((child) => processNode(child));
  if (currentLine.children.length > 0) {
    lines.push(currentLine);
  }
  return lines;
}
function groupLinesIntoChunks(lines, linesPerChunk) {
  const chunks = [];
  for (let i = 0; i < lines.length; i += linesPerChunk) {
    const chunkLines = lines.slice(i, i + linesPerChunk);
    const chunkRoot = {
      type: "root",
      children: []
    };
    chunkLines.forEach((line, lineIndex) => {
      const filteredChildren = line.children.filter(guardAstNode);
      chunkRoot.children.push(...filteredChildren);
      if (lineIndex < chunkLines.length - 1) {
        chunkRoot.children.push({
          type: "text",
          value: "\n"
        });
      }
    });
    chunks.push({
      ast: chunkRoot,
      numberOfLines: chunkLines.length
    });
  }
  return chunks;
}
const getAstNodeText = (node) => {
  if (node.type === "text") {
    return node.value;
  }
  if (node.type === "element") {
    const filteredChildren = node.children.filter(guardAstNode);
    return filteredChildren.map(getAstNodeText).join("");
  }
  return "";
};
function createPlaceholderAST(lines) {
  return {
    ast: {
      type: "root",
      children: [
        {
          type: "element",
          tagName: "span",
          properties: {
            className: [
              "code-placeholder"
            ],
            "data-line": "placeholder"
          },
          children: [
            {
              type: "text",
              value: lines.join("\n")
            }
          ]
        }
      ]
    },
    numberOfLines: lines.length
  };
}
function createPlaceholderChunks(code, linesPerChunk) {
  const start = performance.now();
  const lines = code.split("\n");
  const lineChunks = [];
  for (let i = 0; i < lines.length; i += linesPerChunk) {
    lineChunks.push(lines.slice(i, i + linesPerChunk));
  }
  const chunks = lineChunks.map((chunk) => createPlaceholderAST(chunk));
  console.log("createPlaceholderChunks", performance.now() - start);
  return chunks;
}
const renderAst = (content) => {
  return content.map((node, index) => {
    if (node.type === "text") {
      return node.value;
    }
    if (node.type === "element") {
      const { tagName, properties, children } = node;
      return React__default.createElement(tagName, {
        ...properties,
        key: index
      }, renderAst(children));
    }
    return null;
  });
};
const renderAstToHTML = (content) => {
  return content.map((node) => {
    if (node.type === "text") {
      return node.value;
    }
    if (node.type === "element") {
      const { tagName, properties, children } = node;
      const attrs = Object.entries(properties || {}).map(([key, value]) => {
        if (Array.isArray(value) && key === "className") {
          return `class="${value.join(" ")}"`;
        } else if (Array.isArray(value)) {
          return `${key}="${value.join(" ")}"`;
        }
        return `${key}="${value}"`;
      }).join(" ");
      const openTag = attrs ? `<${tagName} ${attrs}>` : `<${tagName}>`;
      const closeTag = `</${tagName}>`;
      return `${openTag}${renderAstToHTML(children)}${closeTag}`;
    }
    return "";
  }).join("");
};

export { createPlaceholderAST, createPlaceholderChunks, getAstNodeText, groupLinesIntoChunks, guardAstNode, renderAst, renderAstToHTML, splitAstByNewlines };
//# sourceMappingURL=ast.js.map
